"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClickTracker = void 0;
var tslib_1 = require("tslib");
var React = require("react");
var clickstream_analytics_context_1 = require("@shared-ui/clickstream-analytics-context");
var withClickTracker = function (WrappedComponent) {
    var ClickTracker = function (props) {
        var rfrr = props.rfrr, linkName = props.linkName, trackImmediate = props.trackImmediate, uisPrimeMicroMessages = props.uisPrimeMicroMessages; // eslint-disable-line react/prop-types
        var newProps = tslib_1.__assign({}, props);
        var clickTracker = (0, clickstream_analytics_context_1.useClickTracker)();
        // no need to pass these down further, if they trickle down to native DOM elements, it will throw an error
        delete newProps.rfrr;
        delete newProps.linkName;
        delete newProps.events;
        delete newProps.trackImmediate;
        delete newProps.uisPrimeMicroMessages;
        if (clickTracker && typeof rfrr === 'string' && typeof linkName === 'string') {
            newProps.onClickCapture = function () {
                clickTracker(rfrr, linkName, trackImmediate, uisPrimeMicroMessages);
            };
        }
        return React.createElement(WrappedComponent, tslib_1.__assign({}, newProps));
    };
    ClickTracker.wrappedComponent = WrappedComponent;
    ClickTracker.displayName = "ClickTracker(".concat(getDisplayName(WrappedComponent), ")");
    return ClickTracker;
};
exports.ClickTracker = withClickTracker;
function getDisplayName(WrappedComponent) {
    return (WrappedComponent === null || WrappedComponent === void 0 ? void 0 : WrappedComponent.displayName) || (WrappedComponent === null || WrappedComponent === void 0 ? void 0 : WrappedComponent.name) || 'Component';
}
//# sourceMappingURL=click-tracker.js.map